// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__hIDt5","footer":"ModalError_footer__3Va2v"};